if (!customElements.get('collection-hero-expand')) {
    customElements.define(
        'collection-hero-expand',
        class CollectionHeroExpand extends HTMLElement {
            constructor() {
                super();
                this.isExpanded = false;
            }

            connectedCallback() {
                this.button = this.querySelector('button');
                this.description = this.querySelector('.collection-hero__description');

                if (!this.button || !this.description) return;

                // Check if description is too long (more than 4 lines on mobile)
                // Use setTimeout to ensure styles are applied
                setTimeout(() => {
                    this.checkHeight();
                }, 100);

                this.button.addEventListener('click', () => {
                    this.toggleExpanded();
                });

                // Re-check on window resize
                window.addEventListener('resize', () => {
                    if (!this.isExpanded) {
                        this.checkHeight();
                    }
                });
            }

            checkHeight() {
                // Only show expand button on mobile (max-width: 749px)
                const isMobile = window.innerWidth <= 749;

                if (!isMobile) {
                    this.button.classList.add('hidden');
                    return;
                }

                // First, measure the full height without any line-clamp
                this.description.style.display = 'block';
                this.description.style.webkitLineClamp = 'unset';
                this.description.style.overflow = 'visible';
                const fullHeight = this.description.scrollHeight;

                // Now apply line-clamp and measure the clamped height
                this.description.style.display = '-webkit-box';
                this.description.style.webkitBoxOrient = 'vertical';
                this.description.style.webkitLineClamp = '4';
                this.description.style.overflow = 'hidden';
                const clampedHeight = this.description.clientHeight;

                // Show button only if content is truncated (more than 4 lines)
                if (fullHeight > clampedHeight) {
                    this.button.classList.remove('hidden');
                } else {
                    this.button.classList.add('hidden');
                }
            }

            toggleExpanded() {
                this.isExpanded = !this.isExpanded;

                if (this.isExpanded) {
                    this.description.classList.add('expanded');
                    this.description.style.display = 'block';
                    this.description.style.webkitLineClamp = 'unset';
                    this.description.style.overflow = 'visible';
                    this.button.textContent = '−'; // minus sign
                    this.button.setAttribute('aria-label', 'Show less');
                } else {
                    this.description.classList.remove('expanded');
                    this.description.style.display = '-webkit-box';
                    this.description.style.webkitBoxOrient = 'vertical';
                    this.description.style.webkitLineClamp = '4';
                    this.description.style.overflow = 'hidden';
                    this.button.textContent = '+';
                    this.button.setAttribute('aria-label', 'Show more');
                }
            }
        }
    );
}
